// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
  import {
    OfferPageResponse,
    OfferPageResponseFromJSON,
    OfferPageResponseToJSON,
    OfferRequest,
    OfferRequestFromJSON,
    OfferRequestToJSON,
    OfferResponse,
    OfferResponseFromJSON,
    OfferResponseToJSON,
    PartnerPageResponse,
    PartnerPageResponseFromJSON,
    PartnerPageResponseToJSON,
    PostPageResponse,
    PostPageResponseFromJSON,
    PostPageResponseToJSON,
    PostRequest,
    PostRequestFromJSON,
    PostRequestToJSON,
    PostResponse,
    PostResponseFromJSON,
    PostResponseToJSON,
    ProjectResponse,
    ProjectResponseFromJSON,
    ProjectResponseToJSON,
  } from '../models';

      export interface CreateOfferRequest {
        offerRequest: OfferRequest;
      }

      export interface CreatePostRequest {
        offerId: number;
        postRequest?: PostRequest;
      }

      export interface DeleteOfferRequest {
        offerId: number;
      }

      export interface GetOfferRequest {
        offerId: number;
      }

      export interface GetOfferPartnersRequest {
        offerId: number;
        pageSize?: number;
        page?: number;
      }

      export interface GetOfferReportRequest {
        offerId: number;
      }

      export interface GetOffersRequest {
        page?: number;
        pageSize?: number;
        project?: string;
        query?: string;
        categories?: Array<number>;
        offerTypes?: Array<number>;
      }

      export interface GetPostsRequest {
        offerId: number;
        pageSize?: number;
        page?: number;
      }

      export interface UpdateOfferRequest {
        offerId: number;
        offerRequest: OfferRequest;
      }


/**
* no description
*/
export interface OffersApi {
    /**
      * Create an offer
    */
    createOffer(requestParameters: CreateOfferRequest): Promise<OfferResponse>
    /**
      * Create a new post
    */
    createPost(requestParameters: CreatePostRequest): Promise<PostResponse>
    /**
      * Delete an offer
    */
    deleteOffer(requestParameters: DeleteOfferRequest): Promise<void>
    /**
      * Represents an offer
    */
    getOffer(requestParameters: GetOfferRequest): Promise<OfferResponse>
    /**
      * Get a page of partners for the given offer.
    */
    getOfferPartners(requestParameters: GetOfferPartnersRequest): Promise<PartnerPageResponse>
    /**
      * Get a report for the offer.
    */
    getOfferReport(requestParameters: GetOfferReportRequest): Promise<ProjectResponse>
    /**
      * Paged list of offers
    */
    getOffers(requestParameters: GetOffersRequest): Promise<OfferPageResponse>
    /**
      * Get a list of posts for the given offer.
    */
    getPosts(requestParameters: GetPostsRequest): Promise<PostPageResponse>
    /**
      * Update an offer
    */
    updateOffer(requestParameters: UpdateOfferRequest): Promise<OfferResponse>
}

  /**
  * no description
  */
  export class OffersApiImpl extends runtime.BaseAPI implements OffersApi {

    /**
      * Create an offer
    */
    async createOfferRaw(requestParameters: CreateOfferRequest): Promise<runtime.ApiResponse<OfferResponse>> {
          if (requestParameters.offerRequest === null || requestParameters.offerRequest === undefined) {
          throw new runtime.RequiredError('offerRequest','Required parameter requestParameters.offerRequest was null or undefined when calling createOffer.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/offers`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: OfferRequestToJSON(requestParameters.offerRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OfferResponseFromJSON(jsonValue));
      }

      /**
        * Create an offer
      */
      async createOffer(requestParameters: CreateOfferRequest): Promise<OfferResponse> {
        const response = await this.createOfferRaw(requestParameters);
        return await response.value();
      }

    /**
      * Create a new post
    */
    async createPostRaw(requestParameters: CreatePostRequest): Promise<runtime.ApiResponse<PostResponse>> {
          if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
          throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling createPost.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/offers/{offerId}/posts`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
              body: PostRequestToJSON(requestParameters.postRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostResponseFromJSON(jsonValue));
      }

      /**
        * Create a new post
      */
      async createPost(requestParameters: CreatePostRequest): Promise<PostResponse> {
        const response = await this.createPostRaw(requestParameters);
        return await response.value();
      }

    /**
      * Delete an offer
    */
    async deleteOfferRaw(requestParameters: DeleteOfferRequest): Promise<runtime.ApiResponse<void>> {
          if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
          throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling deleteOffer.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/offers/{offerId}`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      });

        return new runtime.VoidApiResponse(response);
      }

      /**
        * Delete an offer
      */
      async deleteOffer(requestParameters: DeleteOfferRequest): Promise<void> {
        await this.deleteOfferRaw(requestParameters);
      }

    /**
      * Represents an offer
    */
    async getOfferRaw(requestParameters: GetOfferRequest): Promise<runtime.ApiResponse<OfferResponse>> {
          if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
          throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getOffer.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/offers/{offerId}`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OfferResponseFromJSON(jsonValue));
      }

      /**
        * Represents an offer
      */
      async getOffer(requestParameters: GetOfferRequest): Promise<OfferResponse> {
        const response = await this.getOfferRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a page of partners for the given offer.
    */
    async getOfferPartnersRaw(requestParameters: GetOfferPartnersRequest): Promise<runtime.ApiResponse<PartnerPageResponse>> {
          if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
          throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getOfferPartners.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/offers/{offerId}/partners`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PartnerPageResponseFromJSON(jsonValue));
      }

      /**
        * Get a page of partners for the given offer.
      */
      async getOfferPartners(requestParameters: GetOfferPartnersRequest): Promise<PartnerPageResponse> {
        const response = await this.getOfferPartnersRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a report for the offer.
    */
    async getOfferReportRaw(requestParameters: GetOfferReportRequest): Promise<runtime.ApiResponse<ProjectResponse>> {
          if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
          throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getOfferReport.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/offers/{offerId}/report`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => ProjectResponseFromJSON(jsonValue));
      }

      /**
        * Get a report for the offer.
      */
      async getOfferReport(requestParameters: GetOfferReportRequest): Promise<ProjectResponse> {
        const response = await this.getOfferReportRaw(requestParameters);
        return await response.value();
      }

    /**
      * Paged list of offers
    */
    async getOffersRaw(requestParameters: GetOffersRequest): Promise<runtime.ApiResponse<OfferPageResponse>> {
      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.project !== undefined) {
              queryParameters['project'] = requestParameters.project;
          }

          if (requestParameters.query !== undefined) {
              queryParameters['query'] = requestParameters.query;
          }

          if (requestParameters.categories) {
            queryParameters['categories'] = requestParameters.categories;
          }

          if (requestParameters.offerTypes) {
            queryParameters['offerTypes'] = requestParameters.offerTypes;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/offers`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OfferPageResponseFromJSON(jsonValue));
      }

      /**
        * Paged list of offers
      */
      async getOffers(requestParameters: GetOffersRequest): Promise<OfferPageResponse> {
        const response = await this.getOffersRaw(requestParameters);
        return await response.value();
      }

    /**
      * Get a list of posts for the given offer.
    */
    async getPostsRaw(requestParameters: GetPostsRequest): Promise<runtime.ApiResponse<PostPageResponse>> {
          if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
          throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getPosts.');
          }

      const queryParameters: runtime.HTTPQuery = {};

          if (requestParameters.pageSize !== undefined) {
              queryParameters['pageSize'] = requestParameters.pageSize;
          }

          if (requestParameters.page !== undefined) {
              queryParameters['page'] = requestParameters.page;
          }

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/offers/{offerId}/posts`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => PostPageResponseFromJSON(jsonValue));
      }

      /**
        * Get a list of posts for the given offer.
      */
      async getPosts(requestParameters: GetPostsRequest): Promise<PostPageResponse> {
        const response = await this.getPostsRaw(requestParameters);
        return await response.value();
      }

    /**
      * Update an offer
    */
    async updateOfferRaw(requestParameters: UpdateOfferRequest): Promise<runtime.ApiResponse<OfferResponse>> {
          if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
          throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling updateOffer.');
          }

          if (requestParameters.offerRequest === null || requestParameters.offerRequest === undefined) {
          throw new runtime.RequiredError('offerRequest','Required parameter requestParameters.offerRequest was null or undefined when calling updateOffer.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

          headerParameters['Content-Type'] = 'application/json';

            if (this.configuration && (this.configuration.accessToken || this.configuration.apiKey)) {
            const token = this.configuration.accessToken || this.configuration.apiKey;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
            headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
            }
      const response = await this.request({
      path: `/offers/{offerId}`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
              body: OfferRequestToJSON(requestParameters.offerRequest),
      });

              return new runtime.JSONApiResponse(response, (jsonValue) => OfferResponseFromJSON(jsonValue));
      }

      /**
        * Update an offer
      */
      async updateOffer(requestParameters: UpdateOfferRequest): Promise<OfferResponse> {
        const response = await this.updateOfferRaw(requestParameters);
        return await response.value();
      }

    }
